


















import { Vue, Component } from "vue-property-decorator"

const AppProps = Vue.extend({
	props: {
	}
})

@Component({})
export default class Calculator extends AppProps {
	idx = 0;
	equation = ""

	get buttonContent() {
		return Array(9).fill(1).map((x, y) => x + y).concat(["ESC", "0", ".", "*", "/", "+", "-"])
	}
}
